<div class="kpi-small-container" [ngClass]="{'clickable': isClickable()}" matRipple [matRippleDisabled]="!isClickable()" (click)="clicked.emit()">
    <div class="text-container" [class.g-loader-s]="isLoading()">
        <span class="data-s-medium count">{{ values() }}</span>
        <span #titleSpan class="text data-xxs" [matTooltip]="text()"
              [matTooltipDisabled]="!Utils.isTextOverflowing(titleSpan)">{{ text() }}
        </span>
    </div>
    @if (badgeConfig()) {
        <app-ui-badge [badgeConfig]="badgeConfig()" [isLoading]="isLoading()" [isResponsive]="true"></app-ui-badge>
    }
</div>